import type { CloseProps } from '../apps/project-management/ActionItemPopup';

export const openActivityPopup = (activityId: number, onClose?: (props: CloseProps) => void) => {
  const url = `${window.wbConfig.baseUrl}/activity/aI?id=${activityId}`;
  // A remote card has no DOM source element; the legacy popup still needs a jQuery set.
  openFullPopUp(aiFullViewPopUp, url, $(), onClose);
};
